import { useEffect, useRef } from 'react'

import { gsap } from 'gsap'

import {
  StyledProgressWrapper,
  StyledActiveBar,
  StyledInactiveBar,
  StyledAtiveBarWrapper,
  StyledInactiveBarWrapper,
} from './index.styled'

type Props = {
  value: number
  country: string
}

const animationSpeed = 0.25

const ProgressBarAnimation = ({ value, country }: Props) => {
  const el = useRef(null)
  const q = gsap.utils.selector(el)
  const activeBars = parseInt(`${value / 10}`)

  useEffect(() => {
    const timeline = gsap.timeline()
    q(`.animation-bar-active`).forEach((el: HTMLElement | null, i) => {
      timeline.fromTo(
        el,
        {
          opacity: 0,
        },
        {
          opacity: 1,
          duration: animationSpeed,
        },
        i * animationSpeed,
      )
    })
  }, [country])

  return (
    <StyledProgressWrapper ref={el}>
      <StyledInactiveBarWrapper>
        {Array(10)
          .fill('inactive')
          .map((x, index) => (
            <StyledInactiveBar key={`${x}-${index}`} />
          ))}
      </StyledInactiveBarWrapper>
      <StyledAtiveBarWrapper>
        {Array(activeBars)
          .fill('active')
          .map((x, index) => (
            <StyledActiveBar
              key={`${x}-${index}`}
              className={`animation-bar-active animation-bar-${index}`}
            />
          ))}
      </StyledAtiveBarWrapper>
    </StyledProgressWrapper>
  )
}

export { ProgressBarAnimation }
